import React from 'react';
import PropTypes from 'prop-types';

import { connect as reduxConnect } from 'react-redux';
import { actions } from '#redux/reducers';
import { roAPI } from '#utils/axiosAPI';
import styles from './formRequestPassword.module.css';
import { Input } from '../../UI/input/input';
import { Controller, useForm } from 'react-hook-form';
import { Field, FieldError, FieldLabel } from '../../UI/form/form';


const FormRequestPassword = ({ onAfterSubmit, alert }) => {
  const form = useForm({
    defaultValues: {
      email: '',
    },
    mode: 'onChange',
  });

  const handleFormSubmit = async (data) => {
    try {
      await roAPI.post('/auth/request/password/email', {
        email: data.email,
      });
      onAfterSubmit('/auth/inicio', 'redirect');
      alert({
        type: 'success',
        title: '¡Estas a un solo paso!',
        message:
          'Te hemos enviado un correo con las instrucciones para restablecer tu contraseña. Por favor revisa tu bandeja de entrada.',
      });
    } catch (error) {
      // handle error if needed
    }
  };

  return (
    <div data-testid="FormLogin">
      <p>Se enviaran las instrucciones a tu correo.</p>
      <form className={styles.form} onSubmit={form.handleSubmit(handleFormSubmit)} id="formLogin">
        <div className={styles['field-group']}>
          <Controller
            control={form.control}
            name="email"
            rules={{
              required: {
                value: true,
                message: 'El correo electrónico es obligatorio.',
              },
              pattern: { value: /^\S+@\S+$/i, message: 'El correo electrónico es inválido.' },
            }}
            render={({ field, fieldState }) => (
              <Field data-invalid={fieldState.invalid}>
                <FieldLabel data-invalid={fieldState.invalid} htmlFor="email">
                  Correo electrónico
                </FieldLabel>
                <Input {...field} id="email" aria-invalid={fieldState.invalid} placeholder="Correo electrónico" autoComplete="on" />
                {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
              </Field>
            )}
          />
        </div>
        <button type="submit" className={`btn btn-une ${styles['btn-submit']}`}>
          Solicitar cambio
        </button>
      </form>
    </div>
  );
};

FormRequestPassword.propTypes = {
  onAfterSubmit: PropTypes.func,
  alert: PropTypes.func,
};

FormRequestPassword.defaultProps = {
  onAfterSubmit: f => f,
  alert: f => f,
};

export default reduxConnect(
  () => ({}),
  dispatch => ({
    alert: alert => dispatch(actions.alert(alert)),
  }),
)(FormRequestPassword);
